import { isNil } from 'lodash';

const checkLock = (options) => {
  const latest = options && options.latest;
  const threshold = options && options.threshold;
  const now = options && options.now;

  const error = [];

  // null and undefined are allowed values if user didn't interact before
  if (!Number.isSafeInteger(latest) && !isNil(latest)) {
    error.push(`bad "latest" value: ${latest}`);
  }

  if (!Number.isSafeInteger(threshold)) {
    error.push(`bad "threshold" value: ${threshold}`);
  }

  if (!Number.isSafeInteger(now)) {
    error.push(`bad "now" value: ${now}`);
  }

  if (error.length) return { error };

  // a threshold of 0 signals no automatic locking is enabled
  // for invalid latest, diff will be NaN and future will be false, as expected
  const auto = threshold > 0;
  const diff = latest + threshold - now;
  const future = diff >= 0;
  const locked = !future && auto;

  return { auto, diff, future, locked };
};

// noinspection JSUnusedGlobalSymbols
export default checkLock;
